import { Resource } from './resource';
import { MailReportErrorInputArgs, MailReportErrorInputVariables } from './queryVariables/mail';
export class MailResource extends Resource {
    reportError(variables) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: MailReportErrorInputVariables,
                reportError: {
                    __args: MailReportErrorInputArgs
                }
            }
        });
        return this.mutation({
            mutation,
            variables
        }, 'reportError');
    }
    reportRemoveAccount() {
        const mutation = this.prepareOptions({
            mutation: {
                reportRemoveAccount: {}
            }
        });
        return this.mutation({ mutation }, 'reportRemoveAccount');
    }
}
export const mailResource = new MailResource();
//# sourceMappingURL=mail.resource.js.map